import type { alert, confirm, openAlertDialog } from "./alert.js";
import { UserSession } from "./UserSession.js";
import "./errorHandler.js";
import type { expose } from "./expose.js";
import type { getLocalizedString } from "./getLocalizedString.js";
import type { localize } from "./localize.js";
import afLocalStorage from "./localStorage.js";
import type { getSessionData, logActivity, logError, startActivity, time } from "./log.js";

export { default as mitt } from "mitt";
export { toLocalDateTime, toLocalISODate, toLocalISODateTime } from "./date.js";
export { downloadBlob } from "./downloadBlob.js";
export type { DownloadItem, DownloadParameters } from "./downloadRequest.js";
export { downloadRequest } from "./downloadRequest.js";
export { expose } from "./expose.js";
export { getLocalizedString } from "./getLocalizedString.js";
export type { getUserImageOptions } from "./getUserImage.js";
export { getUserImage } from "./getUserImage.js";
export { invariant } from "./invariant.js";
export { localize } from "./localize.js";
export { afLocalStorage as localStorage };
export { getSessionData, logActivity, logError, startActivity, time } from "./log.js";
export { default as SessionHandler } from "./SessionHandler.js";
export { UserSession };
export type { AlertDialogButton, AlertDialogOptions, AlertOptions, ConfirmOptions } from "./alert.js";
export { alert, ConfirmButtons, confirm, openAlertDialog, waitForDialog } from "./alert.js";
export { getSettings, saveSettings } from "./settings.js";

// biome-ignore lint/correctness/noInvalidUseBeforeDeclaration: this is injected build time
export const version = __VERSION__;

declare global {
	var __VERSION__: string;
	var __DEV__: number;
	var af: AfCore;

	interface Window {
		af: AfCore;
	}
}

export interface AfArticle {
	hostName: string;
	i18n: Record<string, string>;
	id: string;
	version?: string;
}

export interface AfCore {
	article: AfArticle;
	common: {
		getLocalizedString: typeof getLocalizedString;
		expose: typeof expose;
		getSessionData: typeof getSessionData;
		localize: typeof localize;
		localStorage: typeof afLocalStorage;
		logActivity: typeof logActivity;
		logError: typeof logError;
		startActivity: typeof startActivity;
		alert: typeof alert;
		confirm: typeof confirm;
		openAlertDialog: typeof openAlertDialog;
		time: typeof time;
		version?: string;
	};
	controls?: {
		alert?: (message: string, callback?: () => void) => void;
		confirm?: (options: {
			title: string;
			message: string;
			buttons: string[];
			callback: (button: number) => void;
		}) => void;
	};
	userSession: UserSession;
}
